import { styled } from 'styled-components'
import PropTypes from 'prop-types'
import { IconWrapper, Svg } from 'common-ui-components/src/vtj/icon/Icon.sc'
import vaakaIconsUrl from 'common-ui-components/src/assets/icons/vaaka-icons.svg'
import suomiFiIconsUrl from 'common-ui-components/src/assets/icons/suomifi-icons.svg'
import newSuomiFiIconsUrl from 'common-ui-components/src/assets/icons/new-suomifi-icons.svg'

/**
 * @deprecated. Use SFI design systems icons instead
 * @see https://designsystem.suomi.fi/styles/icons/
 */
const Icon = styled(
  ({ iconColor, iconId, height, width, rotation = 0, ...rest }) => (
    <IconWrapper
      role="img"
      aria-hidden="true"
      height={height}
      width={width}
      {...rest}
    >
      <Svg height={height} width={width} rotation={rotation}>
        <use
          xlinkHref={resolveIconUrl(iconId)}
          fill={iconColor}
          suppressHydrationWarning
        />
      </Svg>
    </IconWrapper>
  )
)``

function resolveIconUrl(iconId) {
  if (iconId.startsWith('new-suomifi-')) {
    return `${newSuomiFiIconsUrl}#${iconId.replace('new-suomifi-', '')}`
  }
  if (iconId.startsWith('suomifi-')) {
    return `${suomiFiIconsUrl}#${iconId.replace('suomifi-', '')}`
  }
  return `${vaakaIconsUrl}#${iconId}`
}

Icon.displayName = 'Icon'

Icon.propTypes = {
  iconColor: PropTypes.string,
  iconId: PropTypes.string.isRequired,
  height: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  width: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  rotation: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
}

Icon.defaultProps = {
  iconColor: '#FFFFFF',
  height: 32,
  width: 32,
}

/**
 * @deprecated. Use SFI design systems icons instead
 * @see https://designsystem.suomi.fi/styles/icons/
 */
export default Icon
